export enum PATHS {
  HOME = "/",
  FEATURES = "/features",
  AI_PHOTOSHOOT = "/ai-photoshoot",
  TECH_PACKS = "/tech-packs",
  ACADEMY = "/academy",
  PRICING = "/pricing",
  AMBASSADORS = "/ambassadors",
  ABOUT = "/about",
  PRIVACY_POLICY = "/privacy-policy",
  TERMS_OF_USE = "/terms-of-use",

  BLOG = "/blog",
  BLOG_DETAIL = "/blog/:slug",
  BLOG_CATEGORY = "/blog/category/:slug",
  BLOG_TAG = "/blog/tag/:slug",
  BLOG_AUTHOR = "/blog/author/:slug",

  NEW_PASSWORD = "/reset-password/:token",
  ACCOUNT = "/account",
  LOGIN = "/login",
  CREATE = "/create",
  EMAIL_VERIFY = "/email-verify/:token",
}
